import { useParams } from 'react-router-dom'
import { useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { lighten } from '@mui/material/styles'

import { useAccount, useAuthUser, useMe, useProduct } from 'src/hooks'
import { MAIN_APP_URL } from 'src/constants'
import PlusIcon from 'src/assets/icons/v2/PlusIcon'
import { EUserRoles } from 'src/types'

import { FabSt, FabWrapper } from './page-fab.styled'
import { AboutThisPageBanner } from '../about-this-page'

export const PageFabActions = () => {
  const { data: authUser } = useAuthUser()
  const { data: me } = useMe()
  const { productId, simpleProductId } = useParams()
  const theme = useTheme()

  const [, i18n] = useTranslation()
  const { data: product } = useProduct(productId || simpleProductId, i18n.language)
  const { data: account } = useAccount(product?.account_id, i18n.language)

  if (!product || !account) {
    return null
  }

  const handleNavigate = () => {
    if (!authUser || !product) {
      return
    }
    window.open(`${MAIN_APP_URL}scans/create?productId=${product.id}`, '_self')
  }

  const isSuperadmin = authUser?.roles?.includes(EUserRoles.superadmin)
  const canManageScans = Boolean(authUser && me && (isSuperadmin || me.accountRoles))

  const showPlusButton = canManageScans
  const showInfoButton = true

  if (!showPlusButton && !showInfoButton) {
    return null
  }

  const baseColor = account.primary_color ?? theme.palette.primary.main
  const hoverColor = lighten(baseColor, 0.2)

  return (
    <FabWrapper id="page-fab-actions">
      {showPlusButton && (
        <FabSt
          id="page-fab-actions__create-scan"
          variant="extended"
          size="large"
          onClick={handleNavigate}
          sx={{
            backgroundColor: baseColor,
            '&:hover': {
              backgroundColor: hoverColor,
            },
          }}
        >
          <PlusIcon size="28" />
        </FabSt>
      )}
      {showInfoButton && (
        <AboutThisPageBanner
          color={baseColor}
          hoverColor={hoverColor}
          locale={i18n.language}
          whiteLabelId={account.white_label_id}
        />
      )}
    </FabWrapper>
  )
}


